import { useState } from 'react'
import { api, ErroreApi } from '../servizi/api.ts'
import { Avviso } from '../componenti/Pezzi.tsx'
import { AreaTesto, Bottone, Modale } from '../componenti/base.tsx'

/**
 * Amministrazione > Utenti: «Azzera il secondo fattore» (decisione di Davide del 31/10/2026, 493), per
 * chi ha perso il telefono e i codici di recupero. La finestra dice che cosa succede e chiede il motivo;
 * l'API chiude le sessioni, scrive il registro e avvisa Direzione, DPO e Referente privacy.
 */

const messaggio = (e: unknown) =>
  e instanceof ErroreApi ? e.message : 'Non è andata a buon fine: controlla la connessione e riprova.'

export function AzzeraSecondoFattore({ utente, chiudi, fatto }: {
  utente: { id: string; nome: string; cognome: string; email: string }
  chiudi: () => void
  fatto: (testo: string) => void
}) {
  const [motivo, setMotivo] = useState('')
  const [errore, setErrore] = useState<string | null>(null)
  const [inCorso, setInCorso] = useState(false)
  const chi = `${utente.nome} ${utente.cognome}`

  async function azzera() {
    setErrore(null); setInCorso(true)
    try {
      const e = await api.post<{ sessioni_chiuse: number }>(
        `/amministrazione/utenti/${utente.id}/secondo-fattore/azzera`, { motivo: motivo.trim() })
      fatto(`Il secondo fattore di ${chi} è azzerato`
        + (e.sessioni_chiuse ? ` e ${e.sessioni_chiuse === 1 ? 'la sua sessione aperta è chiusa' : `le sue ${e.sessioni_chiuse} sessioni aperte sono chiuse`}` : '')
        + '. Al prossimo accesso ne attiva uno nuovo.')
    } catch (err) {
      setErrore(messaggio(err))
    } finally {
      setInCorso(false)
    }
  }

  const manca = motivo.trim().length < 5
  return (
    <Modale titolo={`Azzera il secondo fattore di ${chi}`} larga chiudi={chiudi}
            azioni={<>
              <Bottone variante="discreto" onClick={chiudi}>Annulla</Bottone>
              <Bottone variante="critico" inCorso={inCorso} disabled={manca} onClick={() => void azzera()}>
                Azzera il secondo fattore
              </Bottone>
            </>}>
      {errore && <Avviso tipo="errore">{errore}</Avviso>}
      <p className="nota-modulo">{utente.email}</p>
      <h3 className="operatori-titoletto operatori-sezione">Che cosa succede</h3>
      <ul className="operatori-conseguenze">
        <li>L’app di autenticazione e i codici di recupero di {chi} smettono di valere.</li>
        <li>Le sue sessioni aperte si chiudono subito, su ogni computer e telefono.</li>
        <li>
          Al prossimo accesso entra con la password e, se i suoi incarichi lo esigono, attiva subito un secondo
          fattore nuovo.
        </li>
        <li>Direzione, DPO e Referente privacy ricevono un avviso; {chi} ne riceve uno suo.</li>
      </ul>
      <Avviso tipo="attenzione">
        Prima di azzerare accertati che a chiederlo sia proprio {chi}, di persona o al telefono: chi avesse la
        sua password entrerebbe senza il secondo fattore.
      </Avviso>
      <AreaTesto etichetta="Motivo" obbligatorio righe={3} maxLength={500}
                 valore={motivo} cambia={setMotivo}
                 aiuto="Per esempio: telefono perso, chiesto di persona il 31/10. Resta nel registro degli eventi." />
      {manca && <p className="nota-modulo">Per azzerare scrivi il motivo (almeno cinque caratteri).</p>}
    </Modale>
  )
}
